/**
 * @module Helper
 */

import { Component, ViewChild } from '@angular/core';
import { HelperComponent } from '../helper/helper.component';

@Component({
  selector: 'app-helper-bbcode',
  templateUrl: './helper-bbcode.component.html',
  styleUrls: ['./helper-bbcode.component.css']
})
export class HelperBbcodeComponent {

  @ViewChild('helper', { static: true }) modal: HelperComponent;

  constructor() {}

  public show() {
    this.modal.show();
  }

  public hide() {
    this.modal.hide();
  }

}
